export default "__VITE_ASSET__BHO$IL72__"